import React, {useState} from 'react';
import PropTypes from 'prop-types';

// MUI Components
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import {Typography} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

// Styled Components
import {StyledCard} from './styled';

import {reinitiateAuthorization, handleReloadApp} from 'contexts/openIdConnect';

// REDUX
import {connect} from 'react-redux';
import {authErrorSelector, configSelector} from 'redux/slices/appSlice';

const AuthError = ({authError, config}) => {
  const [errorDescriptionIsShown, setErrorDescriptionIsShown] = useState(false);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      style={{marginTop: 70, textAlign: 'center'}}
    >
      <StyledCard style={{padding: 24}}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h6">
            {authError.errorScope
              ? 'You do not have permission to use the DVZA Support Console.'
              : authError.invalidTokenError
              ? 'Your session is expired. Please login again'
              : 'There are problems with logging in. Try again'}
          </Typography>
        </Grid>

        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              onClick={() => reinitiateAuthorization(config.flagshipBaseUrl)}
              variant="contained"
              color="primary"
              style={{marginTop: 24}}
            >
              Home
              <OpenInNewIcon style={{width: 18, marginLeft: 8}} />
            </Button>
            <Button
              onClick={() => handleReloadApp()}
              variant="outlined"
              color="primary"
              style={{marginTop: 24, marginLeft: 24}}
            >
              Retry
            </Button>
          </Grid>
          {authError.description && (
            <Button style={{marginTop: 24}} onClick={() => setErrorDescriptionIsShown(true)}>
              Show Details
            </Button>
          )}
          {errorDescriptionIsShown && <Typography>{authError.description}</Typography>}
        </Grid>
      </StyledCard>
    </Grid>
  );
};

AuthError.propTypes = {
  authError: PropTypes.object,
  config: PropTypes.object
};

const mapStateToProps = (state) => ({
  authError: authErrorSelector(state),
  config: configSelector(state)
});

export default connect(mapStateToProps)(AuthError);
